import images from "./Images"

var info = {
    username: `asta絆`,
    user_pfp: images.vegeta_hard_pos,
    user_cover: images.cover_86,
    bio: "ur future self is talking shit about u :!",
    user_ig_p: 'asta.7z',
    user_x_p: 'stark7z',
    user_g_p: 'asta7z',
    my_story: images.nature1,
    followers_num: 500,
}

export default info